/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type BuildingSubPremiseType =
    (typeof BuildingSubPremiseType)[keyof typeof BuildingSubPremiseType];

export const BuildingSubPremiseType = {
    Unknown: 0,
    Antenna: 1,
    Apartment: 2,
    AutomatedTellerMachine: 3,
    Barbecue: 4,
    Block: 5,
    Boatshed: 6,
    Building: 7,
    Bungalow: 8,
    Cage: 9,
    Carpark: 10,
    Carspace: 11,
    Club: 12,
    Coolroom: 13,
    Cottage: 14,
    Duplex: 15,
    Flat: 16,
    Factory: 17,
    Garage: 18,
    Hall: 19,
    House: 20,
    Kiosk: 21,
    Lobby: 22,
    Loft: 23,
    Lot: 24,
    Office: 25,
    Penthouse: 26,
    Rear: 27,
    Room: 28,
    Reserve: 29,
    Suite: 30,
    Section: 31,
    Shed: 32,
    Shop: 33,
    Showroom: 34,
    Sign: 35,
    Site: 36,
    Stall: 37,
    Store: 38,
    Studio: 39,
    StrataUnit: 40,
    Substation: 41,
    Tenancy: 42,
    Townhouse: 43,
    Tower: 44,
    Unit: 45,
    Villa: 46,
    Vault: 47,
    Ward: 48,
    Lease: 49,
    MarineBerth: 50,
    Maisonette: 51,
    Warehouse: 52,
    Workshop: 53,
} as const;
